import clsx from 'clsx'
import { AlertTriangle } from 'lucide-react'
import { useEffect, useState } from 'react'

import { Badge, Checkbox } from 'slab'
import { conditionallyLocalizeDate } from 'utils'

// Hideous Tailwind utility classes to style raw HTML `<a>` tags within an
// element to match design system link styles
const NESTED_LINK_STYLES = '[&_a]:text-gray-500 [&_a:hover]:text-gray-700 [&_a:focus-visible]:text-gray-700 [&_a]:underline [&_a]:decoration-dotted [&_a:hover]:decoration-solid [&_a]:underline-offset-[0.25rem] [&_a]:transition [&_a]:outline [&_a]:outline-offset-4 [&_a]:outline-2 [&_a]:outline-transparent [&_a:focus-visible]:outline-thatch-500 [&_a]:rounded-sm'

type InstructionProps = {
  id: string
  title: string
  details: string
  deadline?: string
  status: 'pending' | 'completed' | 'canceled'
  onChange?: (id: string, checked: boolean) => void
  isInCompletedSection?: boolean
}

const Instruction = ({ id, title, details, deadline, status, onChange, isInCompletedSection = false }: InstructionProps) => {
  const deadlineDate = deadline ? conditionallyLocalizeDate(new Date(deadline)) : undefined

  const [checked, setChecked] = useState(status === 'completed')

  // Update checked state when status prop changes (after successful PATCH from parent)
  useEffect(() => {
    setChecked(status === 'completed')
  }, [status])

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newChecked = e.target.checked
    // Notify parent of the change - parent will handle the PATCH
    onChange?.(id, newChecked)
  }

  return (
    <div className='flex justify-between items-start gap-3 p-4 border border-gray-200 rounded-lg'>
      {/* Instruction */}
      <Checkbox
        checked={checked}
        onChange={handleCheckboxChange}
        // Use dangerouslySetInnerHTML because instruction.title, details can contain HTML
        label={title && <span className={clsx('body-bold', NESTED_LINK_STYLES, isInCompletedSection && 'text-gray-500')} dangerouslySetInnerHTML={{ __html: title }} />}
        description={details && <span className={clsx('body-sm', NESTED_LINK_STYLES, isInCompletedSection && 'text-gray-500')} dangerouslySetInnerHTML={{ __html: details }} />}
      />
      {/* Deadline badge */}
      {deadlineDate && !isInCompletedSection && (
        <Badge
          type='warning'
          leftIcon={AlertTriangle}
        >
          Action needed by {deadlineDate}
        </Badge>
      )}
    </div>
  )
}

export default Instruction
